import { Component, computed, signal } from '@angular/core';
import { Router } from '@angular/router';
import { IShipment } from '../../interfaces/IShipment';
import { Toolbar } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { TimelineModule } from 'primeng/timeline';
import { DatePipe, JsonPipe, NgIf } from '@angular/common';
import { IAddress } from '../../interfaces/IAddress';
import { DbService } from '../../services/db.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-shipment-detail',
  standalone: true,
  imports: [Toolbar, ButtonModule, CardModule, ChipModule, TimelineModule, NgIf, JsonPipe, DatePipe],
  templateUrl: './shipment-detail.component.html',
  styleUrl: './shipment-detail.component.scss'
})



export class ShipmentDetailComponent {
  shipmentId:number= 0;
  shipment = signal<IShipment>({}as IShipment);
  shipmentHistory  = computed(() => { return this.shipment()?.shipmentHistories || [] });

  constructor(private router: Router,
              private dbService: DbService, private toast: ToastService) {
    const state = this.router.getCurrentNavigation()?.extras.state;
    this.shipmentId = state?.['data'] || 0;
    this.dbService.getShipmentById(this.shipmentId).then(shipment=>{
      if(shipment === null){
        this.toast.error("Shipment was not found");
        this.goBack();
        return;
      }
      this.shipment.set(shipment);
    })    
  }


  goBack(){
    this.router.navigate(['/shipment']);
  }

  getMapUrl(address: IAddress): string {
    return `https://maps.google.com/?q=${encodeURIComponent(`${address.label}`)}`;
  }

  openDeliveryEvidence(){
    this.router.navigate(['/evidence'], { state: { data: this.shipment() } });
  }
}
